export default function AboutSection() {
  return (
    <>
      <section id="about" className="pt-4 pb-8 bg-[#DBCEC5]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {/* Centered section heading */}
          <div className="mb-9 text-center">
            <h2 
              className="text-4xl lg:text-5xl font-normal cinematic-text-dark"
            >
              Guided by&nbsp;Yuliya Yuvati
            </h2>
            <p 
              className="text-xl lg:text-2xl text-[#312921]/85 mt-4"
            >
              10+ years of hands-on, trauma-informed care through creative expression.
            </p>
          </div>
          
          {/* Content grid - same height photo and text */}
          <div className="grid lg:grid-cols-2 gap-4 lg:gap-16 items-start">
            <div className="order-2 lg:order-1 flex justify-center">
              <div className="w-full max-w-md h-[600px]">
                <img
                  src="https://static.readdy.ai/image/36990eb3aa57e3c7d396ac7e72f77043/fc07840cd4131dcc9b18636a25ea1f54.jpeg"
                  alt="Yuliya - Art Therapist"
                  className="w-full h-full rounded-2xl shadow-2xl object-cover object-top"
                />
              </div>
            </div>
            
            <div className="order-1 lg:order-2 lg:h-[600px] flex flex-col justify-between">
              <div className="space-y-2.5 lg:space-y-4 text-base lg:text-xl text-[#312921]/85 leading-[1.85] max-w-xl">
                <p>
                  Art therapy isn't about being good at art — it's about learning a new language for what words alone can't hold. Our past experiences shape our beliefs, our values, the way we see ourselves and the world around us — and they show up in our lives today, often more than we realize, in our relationships, our finances, our health, the way we carry ourselves. Traditional talk therapy can struggle here, because naming what we feel isn't always easy. In my experience, a single line or a simple, even childlike sketch can surface more emotional truth than hours of conversation.
                </p>
                
                <p>
                  This works because images speak through metaphor and symbol — a language older and more universal than words. Carl Jung called this shared inner landscape the collective unconscious: patterns and images that recur across cultures and generations, carrying meaning we recognize before we can fully explain it.
                </p>
                
                <p>
                  I have collaborated with two of Southeast Asia's most established rehabilitation centers — <a href="https://seasonsbali.org/" target="_blank" rel="noopener noreferrer" className="text-[#D6794E] hover:text-[#D6794E] underline underline-offset-2 transition-colors cursor-pointer">Seasons Bali</a> and <a href="https://www.thecabinchiangmai.com/" target="_blank" rel="noopener noreferrer" className="text-[#D6794E] hover:text-[#D6794E] underline underline-offset-2 transition-colors cursor-pointer">The Cabin Chiang Mai</a> — where I developed extensive experience supporting clients through trauma, emotional dysregulation,&nbsp; and addiction recovery.
                </p>
                

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}